<template>
  <nav :class="$style.tablist">
    <ol>
      <li
        v-for="(label, index) in labels"
        :key="index"
        :class="{ [$style.selected]: isSelected(label) }"
      >
        <button @click="selectTab(index)">
          {{ label }}
        </button>
      </li>
    </ol>
  </nav>
  <slot></slot>
</template>

<script>
export default {
  data() {
    return {
      labels: [],
      selectedTab: 0,
    };
  },
  emits: ["selected"],
  methods: {
    registerTab(label) {
      if (this.labels.includes(label)) {
        return;
      }
      this.labels.push(label);
    },
    isSelected(label) {
      return this.labels[this.selectedTab] == label;
    },
    selectTab(index) {
      this.selectedTab = index;
      this.$emit("selected", index, this.labels[index]);
    },
  },
};
</script>

<style lang="scss" module>
.tablist {
  ol {
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0.5rem;
  }

  li {
    transform: skewX(-30deg);
    border: 7px solid steelblue;
    border-right: none;
    border-left: none;
    background-color: dimgray;
    button {
      color: inherit;
      font-weight: inherit;
      transform: skewX(30deg);
      border: none;
      background-color: transparent;
    }
  }
  li:hover {
    background-color: darkgray;
  }

  .selected {
    border-color: hsl(180, 55.6%, 91.2%);
    font-weight: bolder;
  }
}
</style>
